module.exports = __webpack_public_path__ + "static/img/92093CX_1_C_20201121_LC.a554646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92093CX_1_C_20201121_LC.png
// module id = DFt3
// module chunks = 0